// components/CreditWidget.jsx
import { Coins, TrendingDown } from "lucide-react";
import { cn } from "@/lib/utils";

export default function CreditWidget({ balance, costPerResume = null, fileCount = 0, aiEnabled = true }) {
  const totalCost = costPerResume != null && fileCount > 0 ? (costPerResume * fileCount).toFixed(2) : null;
  const afterBalance = balance != null && totalCost != null ? (balance - totalCost).toFixed(2) : null;
  const willExceed = afterBalance != null && Number(afterBalance) < 0;

  if (!aiEnabled) return null; // hide widget entirely when AI is off

  return (
    <div className={cn(
      "flex items-center gap-3 px-3 py-2 rounded-lg border text-sm",
      willExceed
        ? "bg-red-50 border-red-200 text-red-700"
        : "bg-amber-50 border-amber-200 text-amber-800"
    )}>
      <Coins className={cn("h-4 w-4 shrink-0", willExceed ? "text-red-500" : "text-amber-500")} />

      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-semibold">{balance ?? "—"}</span>
        <span className="text-xs opacity-70">credits</span>

        {totalCost != null && (
          <>
            <span className="text-xs opacity-50">•</span>
            <span className="flex items-center gap-1 text-xs">
              <TrendingDown className="h-3 w-3" />
              {totalCost} for {fileCount} resume{fileCount !== 1 ? "s" : ""}
            </span>
            {afterBalance != null && (
              <>
                <span className="text-xs opacity-50">→</span>
                <span className={cn("text-xs font-medium", willExceed && "font-bold")}>
                  {willExceed ? "Insufficient credits" : `${afterBalance} remaining`}
                </span>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}